import { useQuery } from "@apollo/client/react";
import { gql } from "@apollo/client";

export const SEARCH_USERS_QUERY = gql`
  query SearchUsers($search: String!, $excludeProjectId: ID) {
    searchUsers(search: $search, excludeProjectId: $excludeProjectId) {
      id
      email
      fullName
      role
    }
  }
`;

export interface SearchUserResult {
  id: string;
  email: string;
  fullName: string;
  role: string;
}

const MIN_SEARCH_LENGTH = 2;

export function useSearchUsers(search: string, excludeProjectId?: string) {
  const trimmed = search.trim();
  const shouldSearch = trimmed.length >= MIN_SEARCH_LENGTH;

  const { data, loading } = useQuery<{ searchUsers: SearchUserResult[] }>(
    SEARCH_USERS_QUERY,
    {
      variables: {
        search: trimmed,
        excludeProjectId: excludeProjectId ?? null,
      },
      skip: !shouldSearch,
      fetchPolicy: "network-only",
    }
  );

  return {
    users: shouldSearch ? data?.searchUsers ?? [] : [],
    loading: shouldSearch && loading,
    shouldSearch,
  };
}
